import {
  DateRangePicker,
  SingleInputDateRangeField,
} from "@mui/x-date-pickers-pro";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { InputAdornment } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Dayjs } from "dayjs";

const blockedInputProps = {
  readOnly: true,
  onKeyDown: (e: React.KeyboardEvent) => e.preventDefault(),
  onKeyPress: (e: React.KeyboardEvent) => e.preventDefault(),
  onKeyUp: (e: React.KeyboardEvent) => e.preventDefault(),
  onInput: (e: React.FormEvent) => e.preventDefault(),
  onBeforeInput: (e: any) => e.preventDefault(),
  onPaste: (e: React.ClipboardEvent) => e.preventDefault(),
  onCut: (e: React.ClipboardEvent) => e.preventDefault(),
  onChange: (e: React.ChangeEvent) => e.preventDefault(),
  onFocus: (e: React.FocusEvent<HTMLInputElement>) => e.target.blur(),
  style: {
    pointerEvents: "none",
    caretColor: "transparent",
    userSelect: "none",
    WebkitUserSelect: "none",
    MozUserSelect: "none",
    cursor: "default",
  },
} as any;

const blockedInputSx = {
  "& .MuiInputBase-root": {
    cursor: "default !important", // <-- fixes text cursor issue
  },
  "& .MuiInputBase-input": {
    pointerEvents: "none !important",
    caretColor: "transparent !important",
    userSelect: "none !important",
    WebkitUserSelect: "none !important",
    MozUserSelect: "none !important",
  },
  "& .MuiIconButton-root": {
    pointerEvents: "auto !important",
    cursor: "pointer !important",
  },
};

type CommonDateRangePickerProps = {
  value: [any, any]; // you can type with [Dayjs | null, Dayjs | null]
  onChange: (value: [any, any]) => void;
  label?: string;
  placeholder?: string;
  isRequired?: boolean;
  dataTracker?: string;
  isDisabled?: boolean;
  maxDate?: Dayjs;
};

export const CustomDateRangePicker = ({
  value,
  onChange,
  label = "Time Period",
  placeholder = "Select Time Period",
  isRequired,
  dataTracker,
  isDisabled,
  maxDate,
}: CommonDateRangePickerProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateRangePicker
        disabled={isDisabled}
        slots={{ field: SingleInputDateRangeField }}
        value={value}
        onChange={onChange}
        maxDate={maxDate}
        format="DD/MM/YYYY"
        slotProps={{
          textField: {
            size: "small",
            fullWidth: true,
            required: isRequired,
            color: "secondary",
            inputProps: blockedInputProps,
            sx: blockedInputSx,
            placeholder,
            InputLabelProps: { shrink: true },
            label,
            InputProps: {
              endAdornment: (
                <InputAdornment position="end">
                  <CalendarMonthIcon
                    fontSize="medium"
                    sx={{
                      cursor: "pointer",
                      pointerEvents: isDisabled ? "none" : "auto",
                      "&:hover": { color: "secondary.main" },
                    }}
                  />
                </InputAdornment>
              ),
            },
          },
          popper: {
            // popper slot forwards props to a <div>, so cast
            ...({
              "data-tracker": dataTracker,
            } as React.HTMLAttributes<HTMLDivElement>),
          },
        }}
      />
    </LocalizationProvider>
  );
};
